"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectStartEndDateRange = detectStartEndDateRange;
exports.findParam = findParam;
exports.formatParamValue = formatParamValue;
exports.getParam = getParam;
exports.separateParams = separateParams;
var _constants = require("../constants");
var _utils = require("../utils");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function separateParams(queryParams) {
  var _params, _handleMatchingParams;
  var params = (_params = {}, _defineProperty(_params, _constants.QUERY_PARAM_QUALIFIERS, {}), _defineProperty(_params, _constants.QUERY_PARAM_SEARCH, {}), _defineProperty(_params, _constants.QUERY_PARAM_SORT, {}), _defineProperty(_params, "others", []), _params);

  // Handler for param cases
  var handleMatchingParamsMap = (_handleMatchingParams = {}, _defineProperty(_handleMatchingParams, _constants.PARAM_SORT[_constants.CEL].key, function (_ref) {
    var param = _ref.param,
      foundParam = _ref.foundParam;
    params[foundParam.props.param] = param.value;
  }), _defineProperty(_handleMatchingParams, "default", function _default(_ref2) {
    var param = _ref2.param,
      foundParam = _ref2.foundParam;
    params[foundParam.props.param][foundParam.props.key] = params[foundParam.props.param][foundParam.props.key] || [];
    params[foundParam.props.param][foundParam.props.key].push(param.value);
  }), _handleMatchingParams);

  // Handler for unmatched params
  var handleUnmatchedParam = function handleUnmatchedParam(paramPair) {
    var foundOtherParam = findParam({
      paramPair: paramPair,
      otherParam: _constants.OTHER_PARAMS
    });
    var _ref3 = (foundOtherParam === null || foundOtherParam === void 0 ? void 0 : foundOtherParam.props) || {},
      key = _ref3.key;
    params.others.push(foundOtherParam ? {
      key: key,
      value: paramPair.value
    } : paramPair);
  };
  var dateCheckedQueryParams = detectStartEndDateRange(queryParams);
  dateCheckedQueryParams.forEach(function (paramPair) {
    var foundParam = findParam({
      paramPair: paramPair
    });

    // checks for date constants since the key is concatenated
    var splitDateRangeKeys = _constants.PARAM_START_DATE[_constants.CEL].key.split(":");
    var checkForDateRangeParam = paramPair.key.includes(splitDateRangeKeys[0] || splitDateRangeKeys[1] || splitDateRangeKeys[2]);
    if (checkForDateRangeParam) {
      foundParam = _constants.PARAM_START_DATE;
    }
    if (!foundParam) {
      return handleUnmatchedParam(paramPair);
    }
    var param = getParam({
      paramPair: paramPair,
      foundParam: foundParam
    });
    if (!(param !== null && param !== void 0 && param.value)) return;
    var handler = handleMatchingParamsMap[param.key] || handleMatchingParamsMap["default"];
    handler({
      param: param,
      foundParam: foundParam
    });
  });
  return _objectSpread(_objectSpread({}, params), {}, {
    search: (0, _utils.sortParams)(_objectSpread({}, params.search))
  });
}
function formatDateValue(_ref4) {
  var value = _ref4.value,
    _ref4$datesFormated = _ref4.datesFormated,
    datesFormated = _ref4$datesFormated === void 0 ? false : _ref4$datesFormated;
  var concatenatedDate = [];
  var regExpDateStart = new RegExp(_constants.REGEXP_DATE_START);
  var dateSplit = value.split(",");
  dateSplit.forEach(function (date) {
    var isDateFormatValid = false;
    isDateFormatValid = datesFormated ? date.split("~").every(function (date) {
      return regExpDateStart.test(date);
    }) : regExpDateStart.test(date);
    if (isDateFormatValid) {
      concatenatedDate.push("".concat(date));
    }
  });
  return datesFormated ? concatenatedDate.join(",") : concatenatedDate.join("~");
}
function formatNumberRangeValue(_ref5) {
  var value = _ref5.value,
    ranges = _ref5.ranges;
  var sortedRangesIndex = value.split(",").sort(function (a, b) {
    return Number(a) - Number(b);
  });
  return sortedRangesIndex.reduce(function (finalArray, rangeKey) {
    if (rangeKey >= _constants.MAX_NIGHTS_OPTIONS) {
      finalArray.push("".concat(ranges[String(Object.keys(ranges).length)]));
      return finalArray;
    }
    if (rangeKey < _constants.MAX_NIGHTS_OPTIONS) {
      finalArray.push("".concat(ranges[rangeKey]));
    }
    return finalArray;
  }, []).join(",");
}
function formatSortValue(_ref6) {
  var value = _ref6.value;
  var foundSort = _constants.SORT_OPTIONS.find(function (s) {
    return s[_constants.CEL] === value;
  });
  if (foundSort) {
    return foundSort.props;
  }
  return null;
}

/**
 * @notes This function takes a param written as is and reformats it according to a constant/config from your constants.js file.
 * @returns {formatted string}
 */
function formatParamValue(_ref7) {
  var _formatFunctionMap, _config$CEL, _config$gdp;
  var value = _ref7.value,
    config = _ref7.config;
  var datesFormated = value.indexOf("~") >= 0;
  var parsedValue;
  var formatFunctionMap = (_formatFunctionMap = {}, _defineProperty(_formatFunctionMap, _constants.PARAM_TYPE_DATE_RANGE, formatDateValue), _defineProperty(_formatFunctionMap, _constants.PARAM_TYPE_NUMBER_RANGE, formatNumberRangeValue), _defineProperty(_formatFunctionMap, _constants.PARAM_TYPE_SORT, formatSortValue), _formatFunctionMap);
  var formatter = formatFunctionMap[config.type];
  if (formatter) return formatter({
    value: value,
    ranges: (_config$CEL = config[_constants.CEL]) === null || _config$CEL === void 0 ? void 0 : _config$CEL.ranges,
    datesFormated: datesFormated
  });
  if ((_config$gdp = config.gdp) !== null && _config$gdp !== void 0 && _config$gdp.mapping) {
    var arrayValues = value.split(",");
    parsedValue = arrayValues.map(function (value) {
      var _config$gdp2;
      return (_config$gdp2 = config.gdp) === null || _config$gdp2 === void 0 ? void 0 : _config$gdp2.mapping[value];
    }).join(",");
  }
  return parsedValue || value;
}
function getParam(_ref8) {
  var paramPair = _ref8.paramPair,
    foundParam = _ref8.foundParam;
  var key = paramPair.key,
    value = paramPair.value;
  var formattedParamValue = formatParamValue({
    value: value,
    config: foundParam
  });
  if (formattedParamValue === null) return {};
  if ((foundParam === null || foundParam === void 0 ? void 0 : foundParam.type) === _constants.QUERY_PARAM_SORT) {
    formattedParamValue = Object.entries(formattedParamValue).reduce(function (finalString, entry) {
      finalString += "".concat(finalString ? "|" : "").concat(entry[0], ":").concat(entry[1]);
      return finalString;
    }, "");
  }
  return {
    key: key,
    value: (0, _utils.removeDuplicateValues)(formattedParamValue),
    config: foundParam
  };
}
function findParamByStartDate(param, keyWord) {
  var _param$CEL;
  return (_param$CEL = param[_constants.CEL]) === null || _param$CEL === void 0 ? void 0 : _param$CEL.key.toLowerCase().split(":").includes(keyWord);
}
function findParam(_ref9) {
  var paramPair = _ref9.paramPair,
    _ref9$otherParam = _ref9.otherParam,
    otherParam = _ref9$otherParam === void 0 ? null : _ref9$otherParam;
  return (otherParam || _constants.PARAMS).find(function (paramConstant) {
    var _paramConstant$CEL;
    if (findParamByStartDate(paramConstant, paramPair.key.toLowerCase())) return paramConstant;
    return (paramConstant === null || paramConstant === void 0 || (_paramConstant$CEL = paramConstant[_constants.CEL]) === null || _paramConstant$CEL === void 0 || (_paramConstant$CEL = _paramConstant$CEL.key) === null || _paramConstant$CEL === void 0 ? void 0 : _paramConstant$CEL.toLowerCase()) == paramPair.key.toLowerCase();
  });
}

/**
 * @param {{minDate: string, maxDate: string}} - minDate, maxDate // format yyyy-mm, yyyy-mm
 * @returns {minDateExpanded: string, maxDateExpanded: string} // format yyyy-mm-dd~yyyy-mm-dd,yyyy-mm-dd~yyyy-mm-dd 
 */

function expandDateFormat(datesArray) {
  var expand = function expand(dateString) {
    var yearMonth = dateString.split("-");
    var year = parseInt(yearMonth[0], 10);
    var month = parseInt(yearMonth[1], 10);

    // JavaScript Date uses zero-based months, so subtract 1
    var firstDay = new Date(year, month - 1, 1);
    // Getting the last day of the previous month
    var lastDay = new Date(year, month, 0);
    var formatDay = function formatDay(date) {
      return date.toISOString().split("T")[0];
    }; // Formatted as yyyy-mm-ddT<timeZone>

    return "".concat(formatDay(firstDay), "~").concat(formatDay(lastDay));
  };
  var formatedArray = [];
  datesArray.sort();
  datesArray.map(function (element) {
    formatedArray.push(expand(element));
  });
  return formatedArray;
}

/**
 * @param {{sailStartDate?: string, sailEndDate?: string, date?: string}} dateRangeMap
 * @returns {key: string, value: string}
 */
function combineDateRange(dateRangeMap) {
  var _formatedArray;
  var minDate, maxDate, formatedArray;
  var sailStartDate = _constants.PARAM_START_DATE[_constants.CEL].key.split(":")[0];
  var sailEndDate = _constants.PARAM_START_DATE[_constants.CEL].key.split(":")[1];
  var dates = "dates";
  if (dates in dateRangeMap) {
    var _dates = dateRangeMap.dates;
    var datesArray = _dates.split(",");
    formatedArray = expandDateFormat(datesArray).toString();
  } else if (sailStartDate in dateRangeMap && sailEndDate in dateRangeMap) {
    var _sailStartDate = dateRangeMap.sailStartDate,
      _sailEndDate = dateRangeMap.sailEndDate;
    minDate = _sailStartDate;
    maxDate = _sailEndDate;
  }

  // Combine the dates into a string with 'date,date'
  var combinedDates = (_formatedArray = formatedArray) !== null && _formatedArray !== void 0 ? _formatedArray : [minDate, maxDate].join(",");
  return {
    key: _constants.PARAM_START_DATE[_constants.CEL].key.split(":")[0],
    value: combinedDates
  };
}

/**
 * @param {Array<{key: string, value: string}>} queryParams
 * @returns {queryParams} but it formats the dates before adding it back into the query params
 */
function detectStartEndDateRange(queryParams) {
  var dateRangeMap = {};
  var queryParamsWithFormatedDate = queryParams.filter(function (param) {
    var foundParam = findParam({
      paramPair: param
    });
    if (!foundParam) {
      return true;
    }
    if (foundParam.type !== _constants.PARAM_START_DATE.type) {
      return true;
    }
    dateRangeMap[param.key] = param.value;
    return false;
  });
  if (!Object.keys(dateRangeMap).length) {
    return queryParamsWithFormatedDate;
  }
  queryParamsWithFormatedDate.push(combineDateRange(dateRangeMap));
  return queryParamsWithFormatedDate;
}